import { addClass } from "@opten/dom/add-class";
import { Component } from "@opten/compiler/metadata/component";
import { debounce } from "@opten/reactive/debounce";

declare const Swiper: any;

@Component({ className: "js-headline" })
export class HeadlineSliderComponent {
	constructor(private element: HTMLElement) {
		const slider = element.getElementsByClassName(
			"js-headline-slider"
		)[0] as HTMLElement;
		const sliderImg = element.getElementsByClassName(
			"js-headline-slider-img"
		)[0] as HTMLElement;
		const autoplay =
			parseInt(this.element.getAttribute("data-autoplay"), 0) || 0;

		// Fetch all js-headline-slide elements and update their background-image URLs with height
		this.updateSlideBackgroundImages();

		const debouncedUpdate = debounce(
			() => this.updateSlideBackgroundImages(),
			100
		);
		window.addEventListener("resize", debouncedUpdate);

		if (!slider) {
			const s = new Swiper(sliderImg, {
				speed: 1000,
				autoplay:
					autoplay > 0
						? {
								delay: autoplay,
						  }
						: false,
				effect: "fade",
				fadeEffect: {
					crossFade: true,
				},
				simulateTouch: false,
				allowTouchMove: false,
				touchStartPreventDefault: false,
				keyboard: {
					enabled: false,
				},
				loop: true,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
			});
		} else {
			const swiperImg = new Swiper(sliderImg, {
				speed: 1000,
				effect: "fade",
				fadeEffect: {
					crossFade: true,
				},
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
			});
			const swiper = new Swiper(slider, {
				autoplay:
					autoplay > 0
						? {
								delay: autoplay,
						  }
						: false,
				autoHeight: true,
				speed: 1000,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
				thumbs: {
					swiper: swiperImg,
				},
			});
		}
	}

	private updateSlideBackgroundImages(): void {
		const slides = this.element.querySelectorAll(
			".js-headline-slide"
		) as NodeListOf<HTMLElement>;

		slides.forEach((slide) => {
			const computedStyle = window.getComputedStyle(slide);
			const backgroundImage = computedStyle.backgroundImage;

			if (backgroundImage && backgroundImage !== "none") {
				const urlMatch = backgroundImage.match(
					/url\(["']?([^"']+)["']?\)/
				);
				if (urlMatch && urlMatch[1]) {
					let originalUrl = urlMatch[1];

					const parentHeight = this.element.offsetHeight;
					const parentWidth = this.element.offsetWidth;

					originalUrl = originalUrl.replace(/[?&]height=\d+/g, "");
					originalUrl = originalUrl.replace(/[?&]width=\d+/g, "");

					const separator = originalUrl.includes("?") ? "&" : "?";
					const newUrl = `${originalUrl}${separator}height=${parentHeight}&width=${parentWidth}`;

					slide.style.backgroundImage = `url("${newUrl}")`;
				}
			}
		});
	}
}
